import React from 'react';

const NotificationSkeletonCard: React.FC = () => {
    return (
        <div className={`ucheck-kiosk-notif-card `}>
            <div className="notif-text d-flex align-items-center">
                <i className="material-icons-outlined">description</i>
                <span className="spacer" />
                <p
                    className="ucheck-skeleton"
                    style={{
                        width: (20 + Math.random() * 80).toString() + '%',
                    }}
                />
            </div>
            <div className="d-flex align-items-center">
                <i className="material-icons">schedule</i>
                <span className="spacer" />
                <p className="ucheck-skeleton" style={{ width: '20%' }} />
            </div>
        </div>
    );
};

export default NotificationSkeletonCard;
